import type { NotificationConfig, UserNotification } from './userNotification';

/**
 * Registro de configuraciones por tipo de notificación.
 *
 * Para añadir un nuevo tipo se agregar una entrada aquí;
 * el componente de notificación lo renderizará automáticamente
 * según las propiedades declaradas (progreso, botón de acción, etc.).
 */
export const NOTIFICATION_REGISTRY: Record<string, NotificationConfig> = {
  ODOO_PARCEL_PROCESSING: {
    text: 'Progreso de la obtención de datos catastrales y geojson de parcelas',
    icon: 'map',
    showProgress: true,
  },
  VEGETATION_PREDICT_PROCESSING: {
    text: 'Progreso del recálculo del índice de vegetación:',
    icon: 'thermostat',
    showProgress: true,
    showProgressText: false,
  },
  ODOO_PARCEL_FINISHED: {
    text: 'La obtención de datos de ref. catastral y geojson de las parcelas finalizó exitosamente y ya se encuentran graficadas en el GIS.',
    icon: 'map',
    summaryLines: details => {
      const total = details.total_count;
      if (typeof total !== 'number') return [];

      const errorCount = details.error_count ?? 0;
      const successCount =
        details.error_count != null
          ? total - errorCount
          : (details.processed_count ?? total);
      const successPercentage =
        total > 0 ? Math.round((successCount / total) * 100) : 0;

      return [
        `- Parcelas procesadas en total: ${total}`,
        `- Parcelas procesadas con éxito: ${successCount} (${successPercentage}%)`,
      ];
    },
    action: {
      label: 'Descargar errores',
      icon: 'download',
      downloadUrlField: 'errors_download_url',
      buildFileName: (notification: UserNotification, companyName: string) => {
        const timestamp = notification.timestamp ?? new Date().toISOString();
        const [datePart, timePart] = timestamp.split('T');
        const timeFormatted = timePart?.split('.')[0].replace(/:/g, '-') ?? '';
        const dateTime = timeFormatted
          ? `${datePart}T${timeFormatted}`
          : datePart;
        return `${companyName} parcelas con errores ${dateTime}.xlsx`;
      },
    },
  },
  VEGETATION_PREDICT_FINISHED: {
    text: details =>
      `El recálculo del índice de vegetación finalizó exitosamente.`,
    icon: 'thermostat',
  },
  ODOO_PARCEL_FAILED: {
    text: 'Error al procesar los datos de parcelas.',
    icon: 'map',
  },
};
